module.exports = __webpack_public_path__ + "fonts/Roboto-500-cyrillic9.cad7d3d.woff2";